/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-plusplus */
/* eslint-disable no-param-reassign */
import React, { useState } from 'react';
import { Collapse, Select } from "antd";
import PropTypes from 'prop-types';
import MinMax from './MinMax';
import materials from '../../config/material.json';
import materialDimensions from '../../config/materialDimensions.json';
import processes from '../../config/process.json';
import processDimensions from '../../config/processDimensions.json';

const { Option } = Select;
const { Panel } = Collapse;

/**
 * For each dimension in dimensions, see if it contains a name
 * in names.  If so, load up a panels array, which is returned
 * properly sorted by name and by items.
 */
const getPanels = (names = [], dimensions = {}) => {
  const rank = dim => [...materialDimensions, ...processDimensions].indexOf(dim);
  const snames = [...names];
  snames.sort((a, b) => b.length - a.length);
  const panels = [];
  Object.keys(dimensions).forEach(nameDim => {
    for (let i = 0; i < snames.length; i++) {
      const name = snames[i];
      if (nameDim.indexOf(name) >= 0) {
        let dimension = nameDim.replace(`${name} `, '');
        if (name === dimension) {
          dimension = 'Max';
        }
        const value = dimensions[nameDim];
        let panel = panels.find(pan => pan.name === name);
        if (!panel) {
          panel = { name, items: [] };
          panels.push(panel);
        }
        panel.items.push({ dimension, value });
        break;
      }
    };
  });
  panels.sort((a, b) => a.name.localeCompare(b.name));
  panels.forEach(panel => panel.items.sort((a, b) => rank(a.dimension) - rank(b.dimension)));
  // panels.forEach(panel => panel.items.sort((a, b) => a.dimension.localeCompare(b.dimension)));
  return panels;
}

/**
 * For each panel in panels, generate a dimension in an
 * object of dimension/value pairs to be returned.
 * @param panels 
 */
const getDimensions = (panels) => {
  const dimensions = {};
  for (let i = 0; i < panels.length; i++) {
    const panel = panels[i];
    for (let j = 0; j < panel.items.length; j++) {
      const item = panel.items[j];
      if (item.dimension !== null && item.value != null) {
        let dimension;
        if (item.dimension.startsWith("Cold ")) {
          dimension = `Cold ${panel.name} ${item.dimension.substring(5)}`
        } else {
          dimension = `${panel.name} ${item.dimension}`;
        }
        dimensions[dimension] = item.value;
      }
    }
  }
  return dimensions;
}

/**
 * Edit MinMax.  The dimensions object contains name/value pairs representing
 * various dimensions, such as "Aluminum Min: value".  These will be distributed
 * into materials and processes.
 * @param {*} dimensions 
 * @param {*} setDimensions 
 * @returns 
 */
const EditMinMax = ({ dimensions, setDimensions }) => {
  const [materialPanels, setMaterialPanels] = useState(getPanels(materials, dimensions));
  const [activeMaterial, setActiveMaterial] = useState(null);
  const [processPanels, setProcessPanels] = useState(getPanels(processes, dimensions));
  const [activeProcess, setActiveProcess] = useState(null);
  const [selectMaterialValue, setSelectMaterialValue] = useState(null);
  const [selectProcessValue, setSelectProcessValue] = useState(null);

  const addMaterialPanel = (name => {
    const newPanels = materialPanels.concat([{ name, items: [{ dimension: null, value: null }] }]);
    newPanels.sort((a, b) => a.name.localeCompare(b.name));
    setSelectMaterialValue(null);
    setMaterialPanels(newPanels);
    setActiveMaterial(name);
  });

  const usedMaterialPanel = (name => {
    if (!name) {
      return false;
    }
    if (name === 'All') {
      return materialPanels.length !== 0;
    } else if (materialPanels.find(panel => panel.name === 'All')) {
      return true;
    }
    return materialPanels.find(panel => panel.name === name);
  });

  const addProcessPanel = (name => {
    const newPanels = processPanels.concat([{ name, items: [{ dimension: null, value: null }] }]);
    newPanels.sort((a, b) => a.name.localeCompare(b.name));
    setSelectProcessValue(null);
    setProcessPanels(newPanels);
    setActiveProcess(name);
  });

  const usedProcessPanel = (name => processPanels.find(panel => panel.name === name));

  const onChange = () => {
    const newDimensions = getDimensions(materialPanels.concat(processPanels));
    setDimensions(newDimensions);
  }

  const toggleActiveMaterial = name => setActiveMaterial(activeMaterial !== name ? name : undefined)
  const toggleActiveProcess = name => setActiveProcess(activeProcess !== name ? name : undefined)

  return (
    <div>
      <h6><b>Materials</b></h6>
      <Select
        placeholder="Add Material"
        onSelect={item => addMaterialPanel(item)}
        value={selectMaterialValue}
        hidden={materials.filter(material => !usedMaterialPanel(material)).length === 0}
      >
        {materials.filter(material => !usedMaterialPanel(material)).map(material => (
          <Option value={material} disabled={!material}>{material || "----"}</Option>
        ))}
      </Select>
      <Collapse
        accordion
        activeKey={activeMaterial}
      >
        {materialPanels.map((panel, pIdx) => (
          <Panel
            header={panel.name}
            key={panel.name}
            onClick={() => toggleActiveMaterial(panel.name)}
          >
            <div onClick={e => e.stopPropagation()} style={{ width: "100%" }}>
              <table>
                <tbody>
                  {panel.items.map((item, idx) => (
                    <MinMax
                      panels={materialPanels}
                      setPanels={setMaterialPanels}
                      pIdx={pIdx}
                      idx={idx}
                      item={item}
                      selectors={materialDimensions}
                      name={panel.name}
                      onChange={onChange}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </Panel>

        ))}
      </Collapse>
      <br />
      <h6><b>Processes</b></h6>
      <Select
        placeholder="Add Process"
        onSelect={item => addProcessPanel(item)}
        value={selectProcessValue}
        hidden={processes.filter(process => !usedProcessPanel(process)).length === 0}
      >
        {processes.filter(process => !usedProcessPanel(process)).map(process => (
          <Option value={process}>{process}</Option>
        ))}
      </Select>
      <Collapse
        accordion
        activeKey={activeProcess}
      >
        {[...processPanels].map((panel, pIdx) => (
          <Panel
            header={panel.name}
            key={panel.name}
            onClick={() => toggleActiveProcess(panel.name)}
          >
            <div onClick={e => e.stopPropagation()} style={{ width: "100%" }}>
              <table>
                <tbody>
                  {panel.items.map((item, idx) => (
                    <MinMax
                      panels={processPanels}
                      setPanels={setProcessPanels}
                      pIdx={pIdx}
                      idx={idx}
                      item={item}
                      selectors={processDimensions}
                      name={panel.name}
                      onChange={onChange}
                    />
                  ))}
                </tbody>
              </table>
            </div>
          </Panel>
        ))}
      </Collapse>
    </div>
  );
}

EditMinMax.propTypes = {
  dimensions: PropTypes.object.isRequired,
  setDimensions: PropTypes.func.isRequired,
}

export default EditMinMax;


// WEBPACK FOOTER //
// ./src/components/EditSupplierCaps/EditMinMax.jsx